var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAddChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4164_25211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0133 24.7919L10.6667 27.9999V23.9999H8C6.93913 23.9999 5.92172 23.5785 5.17157 22.8283C4.42143 22.0782 4 21.0608 4 19.9999V9.33325C4 8.27239 4.42143 7.25497 5.17157 6.50482C5.92172 5.75468 6.93913 5.33325 8 5.33325H24C25.0609 5.33325 26.0783 5.75468 26.8284 6.50482C27.5786 7.25497 28 8.27239 28 9.33325V16.6666",
    stroke: "#B7B7B7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 25.3333H29.3334",
    stroke: "#B7B7B7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 21.3333V29.3333",
    stroke: "#B7B7B7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4164_25211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddChat);
export default __webpack_public_path__ + "static/media/ic_add_chat.c6cbd06c1913705e6d6df70d4cc7f4bd.svg";
export { ForwardRef as ReactComponent };